import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit} from '@angular/core';

import { OrderService } from '../../services/order.service';
import { PrintService } from '../../services/print.service';
import { AuthenticationService, Token } from '../../services';

@Component({
  selector: 'app-tracking-detail',
  providers: [OrderService, PrintService],
  templateUrl: './tracking-detail.component.html',
  styleUrls: ['./tracking-detail.component.css']
})
export class TrackingDetailComponent implements OnInit, AfterViewInit {

  @Input("order") order: any;
  @Input("trackingNumbers") trackingNumbers: any[]=[];
  @Input("activateLabel") activateLabel: boolean;
  @Input("mlabel") mlabel: boolean;
  @Output("onAddLabel") addLabel = new EventEmitter<any>();
  @Output("onAddLabelManual") addLabelManual = new EventEmitter<any>();
  @Output("onGenerateLabel") generateLabel = new EventEmitter<any>();
  @Output("onManualTracking") manualTracking = new EventEmitter<any>();
  @Output("onRemoveTrackingNumber") removeTrackingNumber = new EventEmitter<any>();
  

  labelModel: string;
  generatingLabels: boolean = false;

  constructor(private orderService: OrderService,
              private printService: PrintService,
              private authenticationService: AuthenticationService) { }

  ngOnInit() {
  //  this.getOrderTrackings(this.order);
  }

  ngAfterViewInit() {
 
  }

  ngOnChanges(changes: any) {
    this.getOrderTrackings(this.order);
  }

  getOrderTrackings(order: any) {
      if (this.order) {
  //      this.trackingNumbers = this.order.trackingNumbers;
      }
      this.generatingLabels = false;
  }

  addNewLabel() {
    this.addLabel.emit();
  }

  addNewLabelManual() {
    this.addLabelManual.emit();
  }

  generateNewLabel(){
    this.generatingLabels = true;
    this.manualTracking.emit(this.labelModel);
    this.generateLabel.emit(this.mlabel);
  }

  removeTracking(trackingNumber: string) { 
     this.removeTrackingNumber.emit(trackingNumber);
  }

  download(trackingNumber: string) {
    window.open(this.orderService.getDownloadURL(this.authenticationService.getToken().value, trackingNumber));
  }

  printLabel(trackingNumber: string): void {
      this._printLabel(trackingNumber);    
  }  


  private async _printLabel(trackingNumber: string): Promise<void> {
    // first download
    window.open(this.orderService.getDownloadURL(this.authenticationService.getToken().value, trackingNumber));
    // then print
    await this.sleep(1000);
    await this.printService.print('labelPrinter', trackingNumber).toPromise();
  }

  sleep(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/orders/tracking-detail/tracking-detail.component.ts